import { Autocomplete, Box, TextField, Typography } from "@mui/material";
import React from "react";
import DownArrow from "../../assets/SVG/downArrow";
import { Label } from "../project/autocomplatePro";

export default function AutoComplate({
  options,
  label,
  placeholder,
  setValue,
  value,
}) {
  return (
    <>
      <Typography
        sx={{
          color: "#000",
          fontSize: "13px",
          fontStyle: "normal",
          fontWeight: "bold",
          lineHeight: "18px",
          mb: "5px",
        }}
      >
        {label}
      </Typography>
      <Autocomplete
        sx={{
          "& .MuiInputBase-root": {
            padding: "2px !important",
            width: "100%",
            borderRadius: "10px",
            border: "1px solid #d0d0d0",
            background: "#f3f3f3",
            // height: "36px",
            outline: "none",
            "& .MuiButtonBase-root": {
              // borderRadius: "8px",
              // bgcolor: "#BAECF6",
            },
            "& .MuiAutocomplete-endAdornment": {
              right: "auto",
              left: "7px !important",
            },
            "& .MuiInputBase-input":{
              height: "17px"
            }
          },
        }}
        // disablePortal
        id="country-select-demo"
        options={options}
        // sx={{ width: 400 }}
        popupIcon={<DownArrow />}
        clearIcon={<></>}
        value={value}
        onChange={(e, option) => setValue(option)}
        getOptionLabel={(option) => option?.name}
        renderOption={(props, option) => {
          return (
            <>
              {option.status === "ACTIVE" && (
                <Box {...props}>{option.name}</Box>
              )}
            </>
          );
        }}
        renderInput={(params) => (
          <TextField
            placeholder={placeholder}
            IconComponent={(props) => {
              // console.log(props);
              return (
                <Box
                  // onClick={() => refInput.current.onClick}
                  {...{ className: "", ...props }}
                  position="absolute !important"
                  top="calc(50% - 0.65em) !important"
                  left="0 !important"
                  right="auto !important"
                  ml="10px !important"
                >
                  <DownArrow />
                </Box>
              );
            }}
            {...params}
          />
        )}
      />
    </>
  );
}
